import { Button } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { useConversationUuid, useTaskStatus } from '~/hooks'
import { AgentTaskStatus, CodePlan } from '~/protos/agents'
import { approvePlan, regeneratePlan } from '~/services/taskService'
import { svg2base64 } from '~/utils/shared'
import { cm } from '~/utils/utils'
import { CurieMarkdown } from '../markdown'

interface SVGPlanProps {
  svgFlows: string[]
  hideSubmitButton: boolean
  codePlan?: CodePlan
}

export function SVGPlan({ svgFlows, hideSubmitButton, codePlan }: SVGPlanProps): JSX.Element {
  const [isApproving, setIsApproving] = useState(false)
  const [isRegenerating, setIsRegenerating] = useState(false)
  const uuid = useConversationUuid()
  const taskStatus = useTaskStatus()

  const onRegeneratePlan = async () => {
    setIsRegenerating(true)
    await regeneratePlan({ uuid })
  }
  const onApprovePlan = async () => {
    setIsApproving(true)
    await approvePlan({ uuid, codePlan })
  }

  useEffect(() => {
    if (taskStatus === AgentTaskStatus.PLANNING_COMPLETED) {
      setIsApproving(false)
      setIsRegenerating(false)
    }
  }, [taskStatus])

  const imageBase64 = svg2base64(svgFlows[0])
  const isDisabled =
    isApproving || isRegenerating || taskStatus === AgentTaskStatus.PLANNING_REREQUESTED
  return (
    <div>
      <CurieMarkdown text={`![](${imageBase64})`} className='p-0' />
      {hideSubmitButton ? null : (
        <div className='flex items-center justify-end mt-3'>
          <Button
            isDisabled={isDisabled}
            disableRipple={true}
            onClick={onRegeneratePlan}
            className={cm(
              'button-submit bg-white ',
              'py-3 px-4 rounded-xl cursor-pointer mr-2',
              'border border-[#c4c4c4] select-none h-12 hover:bg-[#f5f5f6]',
              'disabled:cursor-not-allowed',
              isRegenerating && 'loading-shimmer'
            )}
          >
            Regenerate
          </Button>
          <Button
            isDisabled={isDisabled}
            disableRipple={true}
            onClick={onApprovePlan}
            className={cm(
              'button-submit bg-light-success text-white',
              'py-3 px-4 rounded-xl cursor-pointer',
              'border border-[#1c875e] select-none h-12 hover:bg-[#20986a]',
              'disabled:cursor-not-allowed'
            )}
          >
            Approve
          </Button>
        </div>
      )}
    </div>
  )
}
